"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schedulerSelectors = void 0;
const constants_1 = require("@/app/shared/constants");
const colors_1 = require("@/app/shared/constants/colors");
const helpers_1 = require("@/app/shared/helpers");
const utils_1 = require("@/app/shared/helpers/utils");
const labels_1 = __importDefault(require("@/app/shared/i18n/labels"));
const server_1 = require("@/app/SUMOCEP/server");
const EmailValidator = __importStar(require("email-validator"));
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const reselect_1 = require("reselect");
const constants_2 = require("./constants");
const utils_2 = require("./utils");
const selectSchedulerState = (state) => state.SUMOCEP_scheduler;
const selectGlobalState = (state) => state.global;
const selectServerType = (0, reselect_1.createSelector)(selectGlobalState, (global) => global.serverType);
const selectSchedulerData = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.schedulerData);
const selectWorkspaceData = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.workspaceData);
const selectHostAvailability = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.hostAvailability);
const selectHostMeetings = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.hostMeetings);
const selectIsSettingsOpened = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.isSettingsOpened);
const selectShowWeekends = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.showWeekends);
const selectWorkspaceId = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.workspaceId);
const selectSchedulerParams = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.schedulerParams);
const selectBookingPage = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.bookingPage);
const selectAvailability = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.availability);
const selectAvailabilityCustom = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.availabilityCustom);
const selectAvailabilityRange = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.availabilityRange);
const selectAvailabilityRollingWindow = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.availabilityRollingWindow);
const selectAvailabilityRollingExpiration = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.availabilityRollingExpiration);
const selectCalendarStartAt = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.calendarStartAt);
// !Reminder:  2 weeks are required for slot generation in case of generation on Friday, as it is necessary to receive information about availability for the following week.
const selectCalendarFinishAt = (0, reselect_1.createSelector)(selectCalendarStartAt, (calendarStartAt) => calendarStartAt + 2 * helpers_1.time.week);
const selectHost = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.host);
const selectMainGuest = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.mainGuest);
const selectGuests = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.guests);
const selectUpsertAction = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.upsertAction);
const selectBookAction = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.bookAction);
const selectIsSchedulerDataFetching = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.isSchedulerDataFetching);
const selectIsWorkspaceDataFetching = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.isWorkspaceDataFetching);
const selectIsHostScheduleFetching = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.isHostScheduleFetching);
const selectIsError = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.error);
const selectIsHostScheduleError = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.hostScheduleError);
const selectIsCreateFetching = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.isCreateFetching);
const selectIsCreateError = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.createError);
const selectIsBookFetching = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.isBookFetching);
const selectIsBookSuccess = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.isBookSuccess);
const selectBookError = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.bookError);
const selectHeaderTab = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.headerTab);
const selectLocationItems = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.locationItems);
const selectLocationRoomsItems = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.locationRoomsItems);
const selectLocationResourcesItems = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.locationResourcesItems);
const selectCEPTemplateOptions = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.CEPTemplateOptions);
const selectCEPSelectedTemplate = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.CEPTemplate);
const selectHasBuffer = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.hasBuffer);
const selectCEPSelectedTemplateId = (0, reselect_1.createSelector)(selectCEPSelectedTemplate, (scheduler) => scheduler?.id);
const selectDefaultTemplateId = (0, reselect_1.createSelector)(selectSchedulerState, (schedulerData) => schedulerData.defaultTemplateId);
/**
 * Meeting Type
 */
const selectSelectedServiceIds = (0, reselect_1.createSelector)(selectBookingPage, (bookingPage) => bookingPage.what?.serviceIds || []);
const selectCustomName = (0, reselect_1.createSelector)(selectBookingPage, (bookingPage) => bookingPage.what?.customName || '');
const selectNoteFromHost = (0, reselect_1.createSelector)(selectBookingPage, (bookingPage) => bookingPage.what?.noteFromHost || '');
const selectDuration = (0, reselect_1.createSelector)(selectBookingPage, (bookingPage) => bookingPage.when?.duration);
const selectServiceDurationMinutes = (0, reselect_1.createSelector)(selectSchedulerState, (s) => s.serviceDurationMinutes);
const selectServiceLocationWarning = (0, reselect_1.createSelector)(selectSchedulerState, (s) => s.serviceLocationWarning);
const selectHostLimitWarning = (0, reselect_1.createSelector)(selectSchedulerState, (s) => s.hostLimitWarning);
const selectServiceDurations = (0, reselect_1.createSelector)(selectSchedulerState, (s) => s.serviceDurations);
const selectDurationInMinutes = (0, reselect_1.createSelector)(selectDuration, (duration) => {
    if (!duration?.count)
        return 0;
    return duration.timeUnit === constants_1.TimeUnit.HOUR ? duration.count * 60 : duration.count;
});
const selectShowServiceDurationWarning = (0, reselect_1.createSelector)(selectServiceDurationMinutes, selectDurationInMinutes, (serviceDuration, userDuration) => serviceDuration !== null && userDuration > 0 && userDuration < serviceDuration);
const selectBufferBefore = (0, reselect_1.createSelector)(selectBookingPage, (bookingPage) => helpers_1.bufferTimeConvert.fromStringToEnum(bookingPage.when?.beforeStartTime));
const selectBufferBeforeInMs = (0, reselect_1.createSelector)(selectBookingPage, (bookingPage) => helpers_1.bufferTimeConvert.fromStringToMs(bookingPage.when?.beforeStartTime));
const selectBufferAfter = (0, reselect_1.createSelector)(selectBookingPage, (bookingPage) => helpers_1.bufferTimeConvert.fromStringToEnum(bookingPage.when?.afterEndTime));
const selectBufferAfterInMs = (0, reselect_1.createSelector)(selectBookingPage, (bookingPage) => helpers_1.bufferTimeConvert.fromStringToMs(bookingPage.when?.afterEndTime));
const selectLocationType = (0, reselect_1.createSelector)(selectBookingPage, (bookingPage) => bookingPage.where?.locationTypes?.[0]);
const selectInPersonType = (0, reselect_1.createSelector)(selectBookingPage, (bookingPage) => bookingPage.where?.inPersonType);
const selectPhoneCallType = (0, reselect_1.createSelector)(selectBookingPage, (bookingPage) => bookingPage.where?.phoneCallType);
const selectVideoConferenceType = (0, reselect_1.createSelector)(selectBookingPage, (bookingPage) => bookingPage.where?.videoConferenceType);
const selectLimit = (0, reselect_1.createSelector)(selectBookingPage, (bookingPage) => bookingPage.limit || constants_2.DEFAULT_BOOKING_PAGE.limit);
const selectGuestsLimit = (0, reselect_1.createSelector)(selectBookingPage, (bookingPage) => bookingPage.guestsLimit);
const selectLocations = (0, reselect_1.createSelector)(selectBookingPage, (bookingPage) => bookingPage.where?.locations || []);
const selectLocation = (0, reselect_1.createSelector)(selectLocations, (locations) => locations?.[0]);
const selectLocationRooms = (0, reselect_1.createSelector)(selectBookingPage, (bookingPage) => bookingPage.where?.locationRooms || []);
const selectLocationRoom = (0, reselect_1.createSelector)(selectLocationRooms, (rooms) => rooms?.[0] || '');
const selectLocationResources = (0, reselect_1.createSelector)(selectBookingPage, (bookingPage) => bookingPage.where?.locationResources || []);
const selectLocationResource = (0, reselect_1.createSelector)(selectLocationResources, (resources) => resources?.[0] || '');
const selectCustomAddress = (0, reselect_1.createSelector)(selectBookingPage, (bookingPage) => bookingPage.where?.customAddress || '');
const selectCustomRoom = (0, reselect_1.createSelector)(selectBookingPage, (bookingPage) => bookingPage.where?.customRoom || '');
const selectCustomResource = (0, reselect_1.createSelector)(selectBookingPage, (bookingPage) => bookingPage.where?.customResource || '');
const selectCustomPhone = (0, reselect_1.createSelector)(selectBookingPage, (bookingPage) => bookingPage.where?.customPhone || '');
const selectCustomCountryCode = (0, reselect_1.createSelector)(selectBookingPage, (bookingPage) => bookingPage.where?.customCountryCode || constants_2.DEFAULT_BOOKING_PAGE.where.customCountryCode);
const selectCustomCountryPhoneCode = (0, reselect_1.createSelector)(selectCustomCountryCode, (customCountryCode) => (0, helpers_1.getCountryDataByCode)(customCountryCode).phoneCode);
const selectCalendarTimezone = (0, reselect_1.createSelector)(selectBookingPage, selectCEPSelectedTemplate, (bookingPage, selectedTemplate) => {
    const currentTimezone = bookingPage.calendar?.timeZone || constants_2.DEFAULT_BOOKING_PAGE.calendar.timeZone;
    const availableTimezones = selectedTemplate?.availableTimezonesList?.filter(Boolean) ?? [];
    if (availableTimezones.length === 0 || availableTimezones.includes(currentTimezone)) {
        return currentTimezone;
    }
    return selectedTemplate?.defaultTimeZone || currentTimezone;
});
const selectBufferCustom = (0, reselect_1.createSelector)(selectBufferBefore, selectBufferAfter, selectAvailabilityCustom, helpers_1.generateBufferCustom);
/**
 * Other
 */
const selectCEPTemplates = (0, reselect_1.createSelector)(selectCEPTemplateOptions, selectHeaderTab, (CEPTemplateOptions, headerTab) => headerTab === "INSTANT_MEETING" /* SchedulerHeaderTab.INSTANT_MEETING */
    ? CEPTemplateOptions.filter((option) => option.inviteTemplateType === server_1.InviteTemplateType.SALESFORCE_OBJECTS)
    : CEPTemplateOptions);
const selectIsSchedulerLoaded = (0, reselect_1.createSelector)(selectSchedulerData, (schedulerData) => Boolean(schedulerData));
const selectTenantId = (0, reselect_1.createSelector)(selectSchedulerData, (schedulerData) => schedulerData?.userData?.tenantId);
const selectAuthUser = (0, reselect_1.createSelector)(selectSchedulerData, (schedulerData) => schedulerData?.users?.find((user) => user.id === schedulerData.userData?.userId));
const selectRole = (0, reselect_1.createSelector)(selectSchedulerData, (schedulerData) => schedulerData?.role);
const selectIsCreateOnlyMyBookingPages = (0, reselect_1.createSelector)(selectRole, (role) => !role?.allBookingPages?.includes("CREATE" /* PermissionAction.CREATE */));
const selectHostUser = (0, reselect_1.createSelector)(selectSchedulerData, selectHost, (schedulerData, host) => schedulerData?.users?.find((user) => user.id === host?.id));
const selectHostDefaultVideoIntegration = (0, reselect_1.createSelector)(selectHostUser, (host) => host?.defaultVideoIntegration || undefined);
const selectCalendarParameters = (0, reselect_1.createSelector)(selectCalendarStartAt, selectCalendarFinishAt, selectCalendarTimezone, (calendarStartAt, calendarFinishAt, calendarTimezone) => ({
    start: new Date(calendarStartAt),
    end: new Date(calendarFinishAt),
    startStr: new Date(calendarStartAt).toISOString(),
    endStr: new Date(calendarFinishAt).toISOString(),
    timeZone: calendarTimezone,
}));
const selectFilteredHostMeetings = (0, reselect_1.createSelector)(selectHostMeetings, utils_2.filterDuplicateMeetings);
const selectFilteredHostMeetingsDisabled = (0, reselect_1.createSelector)(selectBookingPage, selectHostAvailability, selectCalendarParameters, (bookingPage, availability, { start, end, startStr, endStr, timeZone }) => {
    const now = new Date();
    const minimumNoticePeriod = bookingPage?.when?.scheduleBuffer;
    const minimumNoticePeriodInMs = (0, utils_2.convertTimeToMsWithTimeUnit)(minimumNoticePeriod?.count, minimumNoticePeriod?.timeUnit);
    const minimumNoticePeriodDate = new Date(now.getTime() + minimumNoticePeriodInMs);
    const minimumNoticePeriodRange = minimumNoticePeriodInMs
        ? [(0, utils_2.createDisabledRange)({ start: now, end: minimumNoticePeriodDate, title: labels_1.default.SCHEDULER_MINIMUM_NOTICE_PERIOD_LABEL })]
        : [];
    return [
        ...(availability
            ? [
                (0, utils_2.createDisabledRange)({ start, end: new Date(availability[0]?.startsAt ?? endStr) }, timeZone),
                ...availability.flatMap((slot, index, array) => {
                    const nextSlot = array[index + 1];
                    return nextSlot
                        ? [(0, utils_2.createDisabledRange)({ start: new Date(slot.finishesAt), end: new Date(nextSlot.startsAt) }, timeZone)]
                        : [];
                }),
                (0, utils_2.createDisabledRange)({ start: new Date(availability.at(-1)?.finishesAt ?? startStr), end: new Date(endStr) }, timeZone),
            ]
            : [(0, utils_2.createDisabledRange)({ start, end }, timeZone)]),
        ...minimumNoticePeriodRange,
    ];
});
const selectSelectedUsersColors = (0, reselect_1.createSelector)(selectHost, selectMainGuest, selectGuests, (host, mainGuest, guests) => ({
    host: { id: host?.id, ...colors_1.HOST_COLOR },
    mainGuest: { id: mainGuest?.id, ...colors_1.MAIN_GUEST_COLOR },
    guests: guests.map((guest, index) => ({
        id: guest.id,
        borderColor: colors_1.GUEST_COLORS[index]?.borderColor ?? colors_1.FALLBACK_COLOR.borderColor,
        backgroundColor: colors_1.GUEST_COLORS[index]?.backgroundColor ?? colors_1.FALLBACK_COLOR.backgroundColor,
        textColor: colors_1.GUEST_COLORS[index]?.textColor ?? colors_1.FALLBACK_COLOR.textColor,
    })),
}));
const selectFilteredHostScheduleAppointments = (0, reselect_1.createSelector)(selectFilteredHostMeetings, selectSelectedUsersColors, (meetings, userColors) => meetings.map((range) => ({
    type: 'SUMO_APPOINTMENT',
    title: range.title,
    start: new Date(range.startsAt).toISOString(),
    end: new Date(range.finishesAt).toISOString(),
    borderColor: (0, utils_1.getUserColor)(range.userId, userColors).borderColor,
    backgroundColor: (0, utils_1.getUserColor)(range.userId, userColors).backgroundColor,
    textColor: (0, utils_1.getUserColor)(range.userId, userColors).textColor,
})));
const selectIsCustomAvailability = (0, reselect_1.createSelector)(selectAvailability, selectHeaderTab, (availability, headerTab) => availability === "CUSTOM" /* SchedulerAvailability.CUSTOM */ || headerTab === "INSTANT_MEETING" /* SchedulerHeaderTab.INSTANT_MEETING */);
const selectAvailabilityRangeStartDate = (0, reselect_1.createSelector)(selectAvailabilityRange, (availabilityRange) => availabilityRange.startDate);
const selectAvailabilityRangeStartTime = (0, reselect_1.createSelector)(selectAvailabilityRange, (availabilityRange) => availabilityRange.startTime);
const selectAvailabilityRangeEndDate = (0, reselect_1.createSelector)(selectAvailabilityRange, (availabilityRange) => availabilityRange.endDate);
const selectAvailabilityRangeEndTime = (0, reselect_1.createSelector)(selectAvailabilityRange, (availabilityRange) => availabilityRange.endTime);
const selectWorkspace = (0, reselect_1.createSelector)(selectSchedulerData, selectWorkspaceId, (schedulerData, workspaceId) => schedulerData?.workspaces?.find((ws) => ws?.id === workspaceId));
const selectMembers = (0, reselect_1.createSelector)(selectSchedulerState, selectSchedulerData, (scheduler, schedulerData) => [
    ...(scheduler.membersData || []),
    ...(schedulerData?.users || []),
]);
const selectMembersById = (0, reselect_1.createSelector)(selectMembers, (members) => members.reduce((acc, member) => {
    if (member.id) {
        acc[member.id] = member;
    }
    return acc;
}, {}));
const selectIsFetchingMembers = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.isFetchingMembers);
const selectPotentialMembers = (0, reselect_1.createSelector)(selectMembers, selectHost, selectMainGuest, selectGuests, utils_2.filterMembers);
const selectSelectedMemberIds = (0, reselect_1.createSelector)(selectMainGuest, selectGuests, (mainGuest, guests) => [
    ...(mainGuest?.id ? [mainGuest.id] : []),
    ...guests.map((guest) => guest.id).filter(Boolean),
]);
const selectLicense = (0, reselect_1.createSelector)(selectSchedulerData, (schedulerData) => schedulerData?.license);
const selectIsBasicLicense = (0, reselect_1.createSelector)(selectLicense, (license) => license?.plan === "BASIC" /* LicensePlan.BASIC */);
const selectIsEngageAiLicense = (0, reselect_1.createSelector)(selectLicense, (license) => license?.plan === "ENGAGE_AI" /* LicensePlan.ENGAGE_AI */);
/**
 * Validation
 */
const selectIsDurationValid = (0, reselect_1.createSelector)(selectDuration, (duration) => Boolean(duration?.count));
const selectIsCustomNameValid = (0, reselect_1.createSelector)(selectCustomName, (customName) => Boolean(customName));
const selectIsRoomValid = (0, reselect_1.createSelector)(selectLocationRooms, (rooms) => Boolean(rooms[0]));
const selectIsResourceValid = (0, reselect_1.createSelector)(selectLocationResources, (resources) => Boolean(resources[0]));
const selectIsCustomAddressValid = (0, reselect_1.createSelector)(selectCustomAddress, selectLocations, (customAddress, locations) => Boolean(customAddress) && Boolean(locations[0]));
const selectIsCustomRoomValid = (0, reselect_1.createSelector)(selectCustomRoom, selectIsRoomValid, (customRoom, room) => Boolean(customRoom) && room);
const selectIsCustomResourceValid = (0, reselect_1.createSelector)(selectCustomResource, selectIsResourceValid, (customResource, resource) => Boolean(customResource) && resource);
const selectIsCustomPhoneValid = (0, reselect_1.createSelector)(selectCustomPhone, (customPhone) => (0, utils_2.validatePhoneNumber)(customPhone));
const selectIsAvailabilityRollingExpirationValid = (0, reselect_1.createSelector)(selectAvailabilityRollingExpiration, (availabilityRollingExpiration) => Boolean(availabilityRollingExpiration));
const selectIsStartDateValid = (0, reselect_1.createSelector)(selectAvailabilityRangeStartDate, (startDate) => Boolean(startDate));
const selectIsStartTimeValid = (0, reselect_1.createSelector)(selectAvailabilityRangeStartTime, (startTime) => Boolean(startTime));
const selectIsEndDateValid = (0, reselect_1.createSelector)(selectAvailabilityRangeStartDate, selectAvailabilityRangeEndDate, (startDate, endDate) => (0, utils_2.validateEndDate)(startDate, endDate));
const selectIsEndTimeValid = (0, reselect_1.createSelector)(selectAvailabilityRangeStartDate, selectAvailabilityRangeStartTime, selectAvailabilityRangeEndDate, selectAvailabilityRangeEndTime, (startDate, startTime, endDate, endTime) => (0, utils_2.validateEndTime)(startDate, startTime, endDate, endTime));
const selectIsHostValid = (0, reselect_1.createSelector)(selectHost, (host) => Boolean(host));
const selectIsMainGuestValid = (0, reselect_1.createSelector)(selectMainGuest, (mainGuest) => EmailValidator.validate(mainGuest?.email || ''));
const selectIsInviteTemplateTypeValid = (0, reselect_1.createSelector)(selectCEPSelectedTemplate, selectIsMainGuestValid, (selectedTemplate, isMainGuestValid) => {
    switch (selectedTemplate?.inviteTemplateType) {
        case server_1.InviteTemplateType.INVITE_LINKS_TAB:
            return true;
        case server_1.InviteTemplateType.SALESFORCE_OBJECTS:
            return isMainGuestValid;
        default:
            return false;
    }
});
const selectIsMainGuestFieldValid = (0, reselect_1.createSelector)(selectHeaderTab, selectIsMainGuestValid, selectIsInviteTemplateTypeValid, (headerTab, isMainGuestValid, isInviteTemplateTypeValid) => {
    switch (headerTab) {
        case "INSTANT_MEETING" /* SchedulerHeaderTab.INSTANT_MEETING */:
            return isMainGuestValid;
        case "OFFER_BOOKING_TIME" /* SchedulerHeaderTab.OFFER_BOOKING_TIME */:
            return isInviteTemplateTypeValid;
        default:
            return false;
    }
});
const selectAppointmentTypes = (0, reselect_1.createSelector)(selectSchedulerData, selectCEPSelectedTemplate, (schedulerData, selectedTemplate) => schedulerData?.servicesOptions?.filter((service) => selectedTemplate?.services?.includes(service.value)) || []);
const selectIsShowLocationVideo = (0, reselect_1.createSelector)(selectSchedulerData, (schedulerData) => schedulerData?.locationOptions?.some((option) => option.type === "VIDEO_CONFERENCE" /* SchedulerLocationTab.VIDEO_CONFERENCE */));
const selectIsShowLocationInPerson = (0, reselect_1.createSelector)(selectSchedulerData, (schedulerData) => schedulerData?.locationOptions?.some((option) => option.type === "IN_PERSON" /* SchedulerLocationTab.IN_PERSON */));
const selectIsShowLocationPhone = (0, reselect_1.createSelector)(selectSchedulerData, (schedulerData) => schedulerData?.locationOptions?.some((option) => option.type === "PHONE_CALL" /* SchedulerLocationTab.PHONE_CALL */));
const selectSelectedServices = (0, reselect_1.createSelector)(selectSelectedServiceIds, selectAppointmentTypes, (serviceIds, appointmentTypes) => appointmentTypes.filter((option) => serviceIds.includes(option.value)));
const selectFilteredLocationOptions = (0, reselect_1.createSelector)(selectIsShowLocationVideo, selectIsShowLocationInPerson, selectIsShowLocationPhone, selectSelectedServices, selectCEPSelectedTemplate, (isShowLocationVideo, isShowLocationInPerson, isShowLocationPhone, selectedServices, selectedTemplate) => {
    const serviceLocationOptions = selectedServices.flatMap((s) => s.locationOptions ?? []);
    const templateLocationOptions = selectedTemplate?.locationOptions ?? [];
    const allowedLocationTypes = serviceLocationOptions.length > 0
        ? serviceLocationOptions
        : templateLocationOptions;
    const allowedTabs = allowedLocationTypes.map((lt) => (0, utils_2.convertFromLocationTypeToSchedulerLocationTab)(lt));
    return constants_2.LOCATION_TYPE_OPTIONS.filter((option) => {
        let isAvailable = false;
        switch (option.value) {
            case "VIDEO_CONFERENCE" /* SchedulerLocationTab.VIDEO_CONFERENCE */:
                isAvailable = !!isShowLocationVideo;
                break;
            case "IN_PERSON" /* SchedulerLocationTab.IN_PERSON */:
                isAvailable = !!isShowLocationInPerson;
                break;
            case "PHONE_CALL" /* SchedulerLocationTab.PHONE_CALL */:
                isAvailable = !!isShowLocationPhone;
                break;
        }
        if (!isAvailable)
            return false;
        if (allowedTabs.length === 0)
            return true;
        return allowedTabs.includes(option.value);
    });
});
const selectFilteredLocationType = (0, reselect_1.createSelector)(selectLocationType, selectFilteredLocationOptions, (locationType, filteredLocationOptions) => {
    const available = filteredLocationOptions.find((option) => option.value === locationType)?.value;
    const fallback = filteredLocationOptions?.[0]?.value;
    return available || fallback;
});
const selectIsLocationValid = (0, reselect_1.createSelector)(selectFilteredLocationType, selectPhoneCallType, selectIsCustomPhoneValid, selectIsCustomAddressValid, (locationType, phoneCallType, customPhoneValid, customAddressValid) => {
    switch (locationType) {
        case "VIDEO_CONFERENCE" /* SchedulerLocationTab.VIDEO_CONFERENCE */:
            return true;
        case "PHONE_CALL" /* SchedulerLocationTab.PHONE_CALL */:
            if (phoneCallType === constants_1.PhoneCallType.CUSTOM_PHONE) {
                return customPhoneValid;
            }
            return true;
        case "IN_PERSON" /* SchedulerLocationTab.IN_PERSON */:
            return customAddressValid;
        default:
            return false;
    }
});
const selectIsAvailabilityValid = (0, reselect_1.createSelector)(selectAvailability, selectIsAvailabilityRollingExpirationValid, selectIsStartDateValid, selectIsStartTimeValid, selectIsEndDateValid, selectIsEndTimeValid, (availability, isAvailabilityRollingExpirationValid, isStartDateValid, isStartTimeValid, isEndDateValid, isEndTimeValid) => {
    switch (availability) {
        case "OPEN" /* SchedulerAvailability.OPEN */:
        case "CUSTOM" /* SchedulerAvailability.CUSTOM */:
            return true;
        case "ROLLING" /* SchedulerAvailability.ROLLING */:
            return isAvailabilityRollingExpirationValid;
        case "RANGE" /* SchedulerAvailability.RANGE */:
            return isStartDateValid && isStartTimeValid && isEndDateValid && isEndTimeValid;
        default:
            return false;
    }
});
const selectIsCalendarValid = (0, reselect_1.createSelector)(selectAvailability, selectAvailabilityCustom, selectHeaderTab, (availability, availabilityCustom, headerTab) => {
    switch (headerTab) {
        case "INSTANT_MEETING" /* SchedulerHeaderTab.INSTANT_MEETING */:
            return Boolean(availabilityCustom[0]);
        case "OFFER_BOOKING_TIME" /* SchedulerHeaderTab.OFFER_BOOKING_TIME */:
            if (availability === "CUSTOM" /* SchedulerAvailability.CUSTOM */) {
                return Boolean(availabilityCustom[0]);
            }
            return true;
        default:
            return false;
    }
});
const selectAvailableTimezones = (0, reselect_1.createSelector)(selectCEPSelectedTemplate, (selectedTemplate) => selectedTemplate?.availableTimezonesList?.filter(Boolean) ?? []);
const selectTimezones = (0, reselect_1.createSelector)(selectAvailableTimezones, (availableTimezonesList) => {
    const allTimezones = moment_timezone_1.default.tz.names();
    const filteredNames = availableTimezonesList.length > 0
        ? availableTimezonesList.filter((tz) => allTimezones.includes(tz))
        : allTimezones;
    return filteredNames.map((tz) => {
        const offset = moment_timezone_1.default.tz(tz).format('Z');
        const zone = `GMT${offset.slice(0, 3)}`;
        return { label: `${tz} (${zone})`, zone, value: tz };
    });
});
const selectIsTimezoneValid = (0, reselect_1.createSelector)(selectTimezones, selectCalendarTimezone, (timezones, timezone) => timezones.some((tz) => tz.value === timezone));
const selectAction = (0, reselect_1.createSelector)(selectUpsertAction, selectBookAction, (upsertAction, bookAction) => Boolean(upsertAction || bookAction));
const selectShowDurationError = (0, reselect_1.createSelector)(selectAction, selectIsDurationValid, (action, isvalid) => action && !isvalid);
const selectShowCustomNameError = (0, reselect_1.createSelector)(selectAction, selectIsCustomNameValid, (action, isvalid) => action && !isvalid);
const selectShowCustomAddressError = (0, reselect_1.createSelector)(selectAction, selectIsCustomAddressValid, (action, isvalid) => action && !isvalid);
const selectShowCustomRoomError = (0, reselect_1.createSelector)(selectAction, selectIsCustomRoomValid, (action, isvalid) => action && !isvalid);
const selectShowCustomResourceError = (0, reselect_1.createSelector)(selectAction, selectIsCustomResourceValid, (action, isvalid) => action && !isvalid);
const selectShowCustomPhoneError = (0, reselect_1.createSelector)(selectAction, selectIsCustomPhoneValid, (action, isvalid) => action && !isvalid);
const selectShowLocationsError = (0, reselect_1.createSelector)(selectAction, selectIsLocationValid, (action, isvalid) => action && !isvalid);
const selectShowStartDateError = (0, reselect_1.createSelector)(selectAction, selectIsStartDateValid, (action, isvalid) => action && !isvalid);
const selectShowStartTimeError = (0, reselect_1.createSelector)(selectAction, selectIsStartTimeValid, (action, isvalid) => action && !isvalid);
const selectShowEndDateError = (0, reselect_1.createSelector)(selectAction, selectIsEndDateValid, (action, isvalid) => action && !isvalid);
const selectShowEndTimeError = (0, reselect_1.createSelector)(selectAction, selectIsEndTimeValid, (action, isvalid) => action && !isvalid);
const selectShowAvailabilityError = (0, reselect_1.createSelector)(selectAction, selectIsAvailabilityValid, (action, isvalid) => action && !isvalid);
const selectShowCalendarError = (0, reselect_1.createSelector)(selectAction, selectIsCalendarValid, (action, isvalid) => action && !isvalid);
const selectShowTimezoneError = (0, reselect_1.createSelector)(selectAction, selectIsTimezoneValid, (action, isvalid) => action && !isvalid);
const selectShowHostError = (0, reselect_1.createSelector)(selectAction, selectIsHostValid, (action, isvalid) => action && !isvalid);
const selectShowMainGuestError = (0, reselect_1.createSelector)(selectAction, selectIsMainGuestFieldValid, (action, isvalid) => action && !isvalid);
const selectIsValidForSave = (0, reselect_1.createSelector)(selectIsDurationValid, selectIsCustomNameValid, selectIsLocationValid, selectIsAvailabilityValid, selectIsHostValid, selectIsMainGuestFieldValid, selectIsCalendarValid, selectIsTimezoneValid, (...args) => args.every(Boolean));
/**
 * Options
 */
const selectHostVideoIntegrationOptions = (0, reselect_1.createSelector)(selectHostUser, (host) => constants_2.VIDEO_INTEGRATION_OPTIONS.filter((option) => host?.integrations?.map((integration) => integration.type).includes(option.value)));
const selectWorkspaceOptions = (0, reselect_1.createSelector)(selectSchedulerData, selectAuthUser, (schedulerData, authUser) => schedulerData?.workspaces
    ?.filter((workspace) => workspace?.id && authUser?.workspaceIds?.includes(workspace.id))
    ?.map((workspace) => ({
    id: workspace?.id,
    name: workspace?.name,
    style: workspace?.style,
    labels: workspace?.labels,
}))
    .map((workspace) => ({
    value: workspace?.id || '',
    label: workspace?.name || '',
})) || []);
const selectToolsOptions = (0, reselect_1.createSelector)(selectSchedulerData, (schedulerData) => schedulerData?.toolsOptions || []);
const selectIsMultipleServiceSelection = (0, reselect_1.createSelector)(selectCEPSelectedTemplate, (selectedTemplate) => selectedTemplate?.multipleServiceSelection ?? false);
const selectMaxServicesPerAppointment = (0, reselect_1.createSelector)(selectCEPSelectedTemplate, (selectedTemplate) => selectedTemplate?.maxServicesPerAppointment);
const selectServiceSelectionLimit = (0, reselect_1.createSelector)(selectHostLimitWarning, selectSelectedServiceIds, selectMaxServicesPerAppointment, (hostLimitWarning, selectedServiceIds, maxServicesPerAppointment) => {
    if (hostLimitWarning)
        return selectedServiceIds.length;
    if (maxServicesPerAppointment)
        return maxServicesPerAppointment;
    return undefined;
});
const selectAvailabilityOptions = (0, reselect_1.createSelector)(selectCEPSelectedTemplate, (selectedTemplate) => selectedTemplate?.availabilityOptions || []);
const selectIsShowLocation = (0, reselect_1.createSelector)(selectSchedulerData, (schedulerData) => !!schedulerData?.locationOptions?.length);
const selectIsShowAvailability = (0, reselect_1.createSelector)(selectAvailabilityOptions, selectHeaderTab, (availabilityOptions, headerTab) => availabilityOptions.length > 0 && headerTab === "OFFER_BOOKING_TIME" /* SchedulerHeaderTab.OFFER_BOOKING_TIME */);
const selectIsShowAvailabilityOpen = (0, reselect_1.createSelector)(selectAvailabilityOptions, (availabilityOptions) => availabilityOptions.some((option) => option === server_1.AvailabilityOptionsType.OPEN));
const selectIsShowAvailabilityCustom = (0, reselect_1.createSelector)(selectAvailabilityOptions, (availabilityOptions) => availabilityOptions.some((option) => option === server_1.AvailabilityOptionsType.CUSTOM));
const selectIsShowAvailabilityRolling = (0, reselect_1.createSelector)(selectAvailabilityOptions, (availabilityOptions) => availabilityOptions.some((option) => option === server_1.AvailabilityOptionsType.ROLLING_WINDOW));
const selectIsShowAvailabilityRange = (0, reselect_1.createSelector)(selectAvailabilityOptions, (availabilityOptions) => availabilityOptions.some((option) => option === server_1.AvailabilityOptionsType.DATE_RANGE));
const selectIsShowBuffer = (0, reselect_1.createSelector)(selectAvailabilityOptions, (availabilityOptions) => availabilityOptions.some((option) => option === server_1.AvailabilityOptionsType.TRAVEL_TIME_GAP));
const selectIsShowLimit = (0, reselect_1.createSelector)(selectHeaderTab, (headerTab) => headerTab === "OFFER_BOOKING_TIME" /* SchedulerHeaderTab.OFFER_BOOKING_TIME */);
const selectFilteredLocation = (0, reselect_1.createSelector)(selectLocation, selectLocationItems, (location, locationItems) => locationItems.find((option) => option.value === location)?.value || '');
const selectFilteredAvailabilityOptions = (0, reselect_1.createSelector)(selectIsShowAvailabilityOpen, selectIsShowAvailabilityCustom, selectIsShowAvailabilityRolling, selectIsShowAvailabilityRange, (isShowAvailabilityOpen, isShowAvailabilityCustom, isShowAvailabilityRolling, isShowAvailabilityRange) => constants_2.AVAILABILITY_OPTIONS.filter((option) => {
    switch (option.value) {
        case "OPEN" /* SchedulerAvailability.OPEN */:
            return isShowAvailabilityOpen;
        case "CUSTOM" /* SchedulerAvailability.CUSTOM */:
            return isShowAvailabilityCustom;
        case "ROLLING" /* SchedulerAvailability.ROLLING */:
            return isShowAvailabilityRolling;
        case "RANGE" /* SchedulerAvailability.RANGE */:
            return false;
        // ! TODO: Temporary disable range availability, need to enable it later after we will fix the issue with the range availability
        // return isShowAvailabilityRange;
        default:
            return false;
    }
}));
const selectFilteredAvailability = (0, reselect_1.createSelector)(selectAvailability, selectFilteredAvailabilityOptions, (availability, filteredAvailabilityOptions) => {
    const available = filteredAvailabilityOptions.find((option) => option.value === availability)?.value;
    const fallback = filteredAvailabilityOptions?.[0]?.value;
    return available || fallback;
});
const selectAvailabilityCalendarParameters = (0, reselect_1.createSelector)(selectAvailabilityRangeStartDate, selectAvailabilityRangeStartTime, selectAvailabilityRangeEndDate, selectAvailabilityRangeEndTime, selectCalendarTimezone, (startDate, startTime, endDate, endTime, timeZone) => {
    const start = (0, utils_2.rangeToDateTime)(startDate, startTime) || constants_2.ONE_YEAR_LIMIT_DATE;
    const end = (0, utils_2.rangeToDateTime)(endDate, endTime) || new Date();
    return {
        start,
        end,
        startStr: start.toISOString(),
        endStr: end.toISOString(),
        timeZone,
    };
});
const selectPayloadAvailabilityCalendarParameters = (0, reselect_1.createSelector)(selectCalendarParameters, selectAvailabilityCalendarParameters, selectFilteredAvailability, (calendarParameters, availabilityCalendarParameters, availability) => {
    switch (availability) {
        case "OPEN" /* SchedulerAvailability.OPEN */:
        case "ROLLING" /* SchedulerAvailability.ROLLING */:
        case "CUSTOM" /* SchedulerAvailability.CUSTOM */:
            return calendarParameters;
        case "RANGE" /* SchedulerAvailability.RANGE */:
            return availabilityCalendarParameters;
    }
});
const selectHostOptions = (0, reselect_1.createSelector)(selectSchedulerData, (schedulerData) => schedulerData?.hosts || []);
/**
 * Saga requests
 */
const selectFinalAvailabilityData = (0, reselect_1.createSelector)(selectFilteredAvailability, selectAvailabilityCustom, selectAvailabilityRange, selectAvailabilityRollingWindow, selectAvailabilityRollingExpiration, utils_2.getAvailabilityData);
const selectFinalBookingPage = (0, reselect_1.createSelector)(selectBookingPage, selectAvailability, selectAvailabilityRollingWindow, selectLimit, selectHost, selectMainGuest, selectGuests, selectCalendarFinishAt, selectWorkspace, selectTenantId, selectAuthUser, selectLocationItems, selectCustomCountryPhoneCode, selectAvailabilityRange, selectFinalAvailabilityData, (bookingPage, availability, availabilityRollingWindow, limit, host, mainGuest, guests, calendarFinishAt, workspace, tenantId, authUser, locationItems, customCountryPhoneCode, availabilityRange, finalAvailabilityData) => ({
    ...bookingPage,
    tenantId: tenantId,
    workspaceId: workspace?.id,
    createdBy: authUser?.id,
    labels: workspace?.labels,
    style: workspace?.style,
    guestsLimit: limit === "UNLIMITED" /* SchedulerLimit.UNLIMITED */ ? undefined : parseInt(limit.replace('LIMIT', '')),
    where: {
        ...bookingPage.where,
        locationItems,
        customCountryPhoneCode,
    },
    who: {
        ...bookingPage.who,
        hostMembers: [(0, utils_2.transformHost)(host)],
        mainGuest: (0, utils_2.transformMember)(mainGuest),
        guests: guests.map(utils_2.transformMember).filter(Boolean),
    },
    when: {
        ...bookingPage.when,
        ...finalAvailabilityData,
        dateRange: (0, utils_2.getDateRange)({ availability, availabilityRollingWindow, calendarFinishAt, availabilityRange }),
    },
}));
const selectFinalInputFields = (0, reselect_1.createSelector)(selectBookingPage, selectMainGuest, (bookingPage, mainGuest) => {
    const hasLocationInput = bookingPage.where?.defaultLocationType === "IN_PERSON" /* SchedulerLocationTab.IN_PERSON */ &&
        bookingPage.where?.inPersonType === constants_1.InPersonType.INVITEE_LOCATION;
    const hasPhoneInput = bookingPage.where?.defaultLocationType === "PHONE_CALL" /* SchedulerLocationTab.PHONE_CALL */ &&
        bookingPage.where?.phoneCallType === constants_1.PhoneCallType.PROMPT_INVITE;
    const defaultFields = (0, utils_2.getDefaultFields)(mainGuest?.name, mainGuest?.email, hasLocationInput || hasPhoneInput);
    if (hasLocationInput) {
        return [...defaultFields, (0, utils_2.getLocationField)()];
    }
    if (hasPhoneInput) {
        return [...defaultFields, (0, utils_2.getPhoneField)()];
    }
    return defaultFields;
});
const selectHostScheduleRequest = (0, reselect_1.createSelector)(selectFinalBookingPage, selectCalendarStartAt, selectCalendarFinishAt, (bookingPage, startAt, finishAt) => ({
    bookingPage,
    startAt,
    finishAt,
}));
exports.schedulerSelectors = {
    selectSchedulerData,
    selectWorkspaceData,
    selectHostAvailability,
    selectHostMeetings,
    selectIsSettingsOpened,
    selectShowWeekends,
    selectWorkspaceId,
    selectSchedulerParams,
    selectBookingPage,
    selectFinalBookingPage,
    selectFinalAvailabilityData,
    selectFinalInputFields,
    selectAvailability,
    selectAvailabilityRollingWindow,
    selectAvailabilityRollingExpiration,
    selectLimit,
    selectGuestsLimit,
    selectCalendarStartAt,
    selectCalendarTimezone,
    selectHost,
    selectMainGuest,
    selectGuests,
    selectUpsertAction,
    selectBookAction,
    selectIsSchedulerDataFetching,
    selectIsWorkspaceDataFetching,
    selectIsHostScheduleFetching,
    selectIsError,
    selectIsHostScheduleError,
    selectIsCreateFetching,
    selectIsCreateError,
    selectIsBookFetching,
    selectIsBookSuccess,
    selectBookError,
    selectHeaderTab,
    selectIsShowLocation,
    selectIsShowLocationPhone,
    selectIsShowLocationVideo,
    selectIsShowLocationInPerson,
    selectIsShowAvailability,
    selectIsShowAvailabilityOpen,
    selectIsShowAvailabilityCustom,
    selectIsShowAvailabilityRolling,
    selectIsShowAvailabilityRange,
    selectIsShowBuffer,
    selectIsShowLimit,
    selectAppointmentTypes,
    selectSelectedServiceIds,
    selectSelectedServices,
    selectAvailabilityOptions,
    selectCustomName,
    selectNoteFromHost,
    selectHasBuffer,
    selectDuration,
    selectServiceDurationMinutes,
    selectServiceLocationWarning,
    selectDurationInMinutes,
    selectShowServiceDurationWarning,
    selectHostLimitWarning,
    selectServiceDurations,
    selectBufferBefore,
    selectBufferBeforeInMs,
    selectBufferAfter,
    selectBufferAfterInMs,
    selectLocationType,
    selectInPersonType,
    selectPhoneCallType,
    selectVideoConferenceType,
    selectLocations,
    selectLocation,
    selectLocationRooms,
    selectLocationRoom,
    selectLocationRoomsItems,
    selectLocationResources,
    selectLocationResource,
    selectLocationResourcesItems,
    selectCustomAddress,
    selectCustomRoom,
    selectCustomResource,
    selectCustomPhone,
    selectCustomCountryCode,
    selectCustomCountryPhoneCode,
    selectIsSchedulerLoaded,
    selectHostDefaultVideoIntegration,
    selectCalendarParameters,
    selectFilteredHostMeetings,
    selectFilteredHostMeetingsDisabled,
    selectFilteredHostScheduleAppointments,
    selectIsCustomAvailability,
    selectAvailabilityRangeStartDate,
    selectAvailabilityRangeStartTime,
    selectAvailabilityRangeEndDate,
    selectAvailabilityRangeEndTime,
    selectAvailabilityCalendarParameters,
    selectAvailabilityCustom,
    selectBufferCustom,
    selectPayloadAvailabilityCalendarParameters,
    selectMembersById,
    selectPotentialMembers,
    selectSelectedMemberIds,
    selectSelectedUsersColors,
    selectHostVideoIntegrationOptions,
    selectWorkspaceOptions,
    selectLocationItems,
    selectToolsOptions,
    selectHostOptions,
    selectHostScheduleRequest,
    selectIsEngageAiLicense,
    selectIsBasicLicense,
    selectCEPSelectedTemplate,
    selectCEPSelectedTemplateId,
    selectCEPTemplateOptions,
    selectCEPTemplates,
    selectDefaultTemplateId,
    selectIsMultipleServiceSelection,
    selectMaxServicesPerAppointment,
    selectServiceSelectionLimit,
    selectAvailableTimezones,
    selectTimezones,
    selectIsTimezoneValid,
    selectFilteredLocation,
    selectFilteredLocationOptions,
    selectFilteredLocationType,
    selectFilteredAvailabilityOptions,
    selectFilteredAvailability,
    selectIsFetchingMembers,
    selectIsDurationValid,
    selectIsCustomNameValid,
    selectIsRoomValid,
    selectIsResourceValid,
    selectIsCustomAddressValid,
    selectIsCustomRoomValid,
    selectIsCustomResourceValid,
    selectIsCustomPhoneValid,
    selectIsAvailabilityRollingExpirationValid,
    selectIsStartDateValid,
    selectIsStartTimeValid,
    selectIsEndDateValid,
    selectIsEndTimeValid,
    selectIsHostValid,
    selectIsMainGuestValid,
    selectIsInviteTemplateTypeValid,
    selectIsMainGuestFieldValid,
    selectIsLocationValid,
    selectIsAvailabilityValid,
    selectIsCalendarValid,
    selectAction,
    selectShowDurationError,
    selectShowCustomNameError,
    selectShowLocationsError,
    selectShowCustomAddressError,
    selectShowCustomRoomError,
    selectShowCustomResourceError,
    selectShowCustomPhoneError,
    selectShowStartDateError,
    selectShowStartTimeError,
    selectShowEndDateError,
    selectShowEndTimeError,
    selectShowHostError,
    selectShowMainGuestError,
    selectShowAvailabilityError,
    selectShowCalendarError,
    selectShowTimezoneError,
    selectIsValidForSave,
};
